import React from 'react';
import { useNavigate } from 'react-router-dom';
import corporateImg from '../assets/globalcity6-plot1.webp';
import './About.css';

export default function About() {
  const navigate = useNavigate();
  return (
    <div className="about-page animate-fade-in-up">
      {/* Mini Hero Header */}
      <section className="page-header">
        <div className="container text-center">
          <span className="section-tag">Corporate Profile</span>
          <h1 className="page-title">Who We Are</h1>
          <p className="page-subtitle">
            Skyon Infra Developers Redefining the Living Luxury with innovation, passion, and perfection.
          </p>
        </div>
      </section>

      {/* Corporate Story */}
      <section className="about-story-section">
        <div className="container grid-2">
          <div className="story-logo-container flex-center">
            <div className="story-image-wrap">
              <img src={corporateImg} alt="Skyon Corporate Headquarters" className="story-image" />
            </div>
          </div>
          <div className="story-content">
            <h2>Redefining The Living Luxury</h2>
            <p className="story-p">
              Founded on the principles of trust, transparency, and top tier construction, Skyon Infra Developers has emerged as one of the region's most reputable real estate developers. We specialize in luxury residential complexes and premium plotted developments that stand as landmarks of quality.
            </p>
            <p className="story-p">
              Our projects are designed around our clients' aspirations. By integrating natural light, open ventilation, high end amenities, and eco friendly infrastructure, we build developments that elevate lifestyle and appreciate continuously in value.
            </p>
            <p className="story-p">
              From foundation to finishing, our dedicated team of engineering, designing, and project managers ensures that every square foot we deliver meets international construction standards and fulfills our promise of luxury living.
            </p>
          </div>
        </div>
      </section>

      {/* Vision & Mission */}
      <section className="vision-mission-section">
        <div className="container">
          <div className="grid-2">
            <div className="premium-card vision-card">
              <span className="card-badge orange-badge">OUR VISION</span>
              <h3>Setting New Benchmarks</h3>
              <p>
                To be the most preferred and trusted real estate and infrastructure development company in the country, recognized for creating iconic residential and plotted developments that redefine luxury and set new industry benchmarks for quality, delivery, and customer delight.
              </p>
            </div>
            <div className="premium-card vision-card">
              <span className="card-badge teal-badge">OUR MISSION</span>
              <h3>Creating Sustainable Value</h3>
              <p>
                To continuously build and deliver outstanding living environments using cutting edge architectural technologies, eco friendly materials, and transparent transaction mechanisms, while maximizing value for our investors and providing unparalleled joy to our home buyers.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Core Values */}
      <section className="values-section">
        <div className="container">
          <div className="text-center">
            <span className="section-tag">Our Foundation</span>
            <h2 className="section-title">Values We Stand <span>By</span></h2>
            <p className="section-desc">
              Every employee, design choice, and business transaction at Skyon is guided by our core values.
            </p>
          </div>
          <div className="grid-3">
            <div className="value-item text-center">
              <div className="value-number">01</div>
              <h3>Absolute Integrity</h3>
              <p>We maintain full legal compliance, RERA filings, and clear property titles, ensuring transparency in every deal.</p>
            </div>
            <div className="value-item text-center">
              <div className="value-number">02</div>
              <h3>Eco-Centric Architecture</h3>
              <p>We build with respect for nature, incorporating rainwater harvesting, tree plantations, and green spaces.</p>
            </div>
            <div className="value-item text-center">
              <div className="value-number">03</div>
              <h3>Customer Centricity</h3>
              <p>Our commitment does not end with handing over keys. We provide post handover support and maintenance guidance.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="about-cta-section text-center">
        <div className="container">
          <h2>Discover Our Developments</h2>
          <p>Explore luxury apartments or premium plots curated specifically for high class living.</p>
          <div style={{ marginTop: '30px', display: 'flex', justifyContent: 'center', gap: '15px' }}>
            <button className="btn btn-primary" onClick={() => navigate('/apartments')}>
              Explore Apartments
            </button>
            <button className="btn btn-secondary" onClick={() => navigate('/plots')}>
              Explore Plots
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}
